<script setup lang="ts">
import {defineEmits, getCurrentInstance, reactive} from "vue";
import Customer from "@/models/Customer";
import countryWorld from "@/shared/constants/countryWorld";
import countryRegion from "@/shared/constants/CountryRegion";
import Nationality from "@/shared/constants/Nationality";
import CustomerIdType from "@/shared/constants/CustomerIdType";
import {useStore} from "vuex";

const country = countryWorld
const region = countryRegion
const nationality = Nationality
const cardIdType = CustomerIdType
const { $alert } = getCurrentInstance().appContext.config.globalProperties;
const emit = defineEmits(['customerSave'])

const store = useStore()
const customer = store.getters['booking/getCustomer']??null
const customerForm = reactive<Customer>({
  cust_birth_place:customer ===null?'':customer.cust_birth_place,
  cust_birthday:customer ===null?'':customer.cust_birthday,
  cust_city:customer ===null?'':customer.cust_city,
  cust_contact:customer ===null?'':customer.cust_contact,
  cust_country:customer ===null?'':customer.cust_country,
  cust_email:customer ===null?'':customer.cust_email,
  cust_date_of_entering_ivory_coast:customer ===null?'':customer.cust_date_of_entering_ivory_coast,
  cust_father_name:customer ===null?'':customer.cust_father_name,
  cust_firstname:customer ===null?'':customer.cust_firstname,
  cust_id_expiration_date:customer ===null?'':customer.cust_id_expiration_date,
  cust_job:customer ===null?'':customer.cust_job,
  cust_lastname:customer ===null?'':customer.cust_lastname,
  cust_mother_name:customer ===null?'':customer.cust_mother_name,
  cust_nationality:customer ===null?'':customer.cust_nationality,
  cust_place_residence:customer ===null?'':customer.cust_place_residence,
  cust_pseudonym:customer ===null?'':customer.cust_pseudonym,
  cust_sexe:customer ===null?'':customer.cust_sexe,
  cust_reference_id:customer ===null?'':customer.cust_reference_id,
  cust_type_id:customer ===null?'':customer.cust_type_id
})
const formValidator = ()=>{
  return customerForm.cust_lastname ==''
      ||customerForm.cust_firstname==''
      ||customerForm.cust_city==''
      ||customerForm.cust_birth_place==''
      ||customerForm.cust_contact==''
      ||customerForm.cust_country==''
      ||customerForm.cust_id_expiration_date==''
      ||customerForm.cust_job==''
      ||customerForm.cust_sexe==''
      ||customerForm.cust_reference_id==''
      ||customerForm.cust_place_residence==''
      ||customerForm.cust_type_id==''
}
const saveCustomer = ()=>{
  if (formValidator()){
    $alert.fire({
      title: 'Ooops!',
      text: "Les champs avec * sont obligatoire",
      icon: 'error',
      confirmButtonColor:'#D62F2F',
      confirmButtonText: 'Compris'
    })
  }else {
    store.dispatch('booking/saveCustomer', customerForm)
    store.dispatch('booking/saveNewCustomer',true)
    emit('customerSave')
  }
}
</script>

<template>
  <div class="uk-container-large uk-margin-top border-outline">
    <h6 class="uk-heading-line uk-text-center uk-text-secondary uk-text-uppercase uk-text-bold"><span>Enregistré ici vous si vous n'êtes jamais inscrit à cette plateforme. </span></h6>
    <form class="uk-grid-small" data-uk-grid>
      <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
        <div class="uk-inline uk-margin-top">
          <label class="uk-form-label" for="form-horizontal-text">Civilité*</label>
          <select v-model="customerForm.cust_sexe" class="uk-select uk-input uk-form-width-large uk-border-rounded csa-input">
            <option value="M.">Monsieur</option>
            <option value="Mme">Madame</option>
            <option value="Mle">Mademoiselle</option>
          </select>
        </div>
      </div>
      <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
        <div class="uk-inline">
          <span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: user"></span>
          <input v-model="customerForm.cust_lastname" class="uk-input uk-input uk-form-width-large uk-border-rounded csa-input" placeholder="Nom(s)*" type="text" aria-label="Not clickable icon">
        </div>
      </div>
      <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
        <div class="uk-inline">
          <span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: user"></span>
          <input v-model="customerForm.cust_firstname" class="uk-input uk-input uk-form-width-large uk-border-rounded csa-input" placeholder="Prénom(s)*" type="text" aria-label="Not clickable icon">
        </div>
      </div>
      <div class="uk-margin-remove-top uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
        <div class="uk-inline">
<!--          <span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: user"></span>-->
          <label class="uk-form-label" for="form-horizontal-text">Date d'anniversaire*</label>

          <input v-model="customerForm.cust_birthday" class="uk-input uk-input uk-form-width-large uk-border-rounded csa-input" placeholder="Date d'anniversaire" type="date" aria-label="Not clickable icon">
        </div>
      </div>
      <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
        <div class="uk-inline">
          <span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: location"></span>
          <input v-model="customerForm.cust_birth_place" class="uk-input uk-input uk-form-width-large uk-border-rounded csa-input" placeholder="Lieu de naissance*" type="text" aria-label="Not clickable icon">
        </div>
      </div>
      <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
        <div class="uk-inline">
          <select v-model="customerForm.cust_type_id" class="uk-select uk-input uk-form-width-large uk-border-rounded csa-input">
            <option disabled selected>Type de pièce d'identité*</option>
            <option :value="idType" v-for="(idType,index) in cardIdType" :key="index">{{idType}}</option>
          </select>
        </div>
      </div>

      <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
        <div class="uk-inline">
          <span  class="uk-form-icon uk-form-icon-flip" uk-icon="icon: credit-card"></span>
          <input v-model="customerForm.cust_reference_id" class="uk-input uk-input uk-form-width-large uk-border-rounded csa-input" placeholder="Réference de la pièce*" type="text" aria-label="Not clickable icon">
        </div>
      </div>
      <div class="uk-margin-remove-top uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
        <div class="uk-inline">
          <label class="uk-form-label" for="form-horizontal-text">Date d'expiration de la pièce*</label>

          <input v-model="customerForm.cust_id_expiration_date" class="uk-input uk-input uk-form-width-large uk-border-rounded csa-input" placeholder="Date d'expiration de la pièce" type="date" aria-label="Not clickable icon">
        </div>
      </div>
      <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
        <div class="uk-inline">
          <span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: phone"></span>
          <input v-model="customerForm.cust_contact" class="uk-input uk-input uk-form-width-large uk-border-rounded csa-input" placeholder="Contact*" type="text" aria-label="Not clickable icon">
        </div>
      </div>
      <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
        <div class="uk-inline">
          <span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: location"></span>
          <input v-model="customerForm.cust_place_residence" class="uk-input uk-input uk-form-width-large uk-border-rounded csa-input" placeholder="Lieu de residence*" type="text" aria-label="Not clickable icon">
        </div>
      </div>
      <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
        <div class="uk-inline">
          <span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: mail"></span>
          <input v-model="customerForm.cust_email" class="uk-input uk-input uk-form-width-large uk-border-rounded csa-input" placeholder="Email" type="text" aria-label="Not clickable icon">
        </div>
      </div>
      <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
        <div class="uk-inline">
          <span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: user"></span>
          <input  v-model="customerForm.cust_job" class="uk-input uk-input uk-form-width-large uk-border-rounded csa-input" placeholder="Profession*" type="text" aria-label="Not clickable icon">
        </div>
      </div>
      <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
        <div class="uk-inline">
          <label class="uk-form-label" for="form-horizontal-text">Pays*</label>

          <select v-model="customerForm.cust_country" class="uk-select uk-input uk-form-width-large uk-border-rounded csa-input">
            <option :value="cust_country[4]" :key="cust_country[0]" v-for="cust_country in country" >{{cust_country[4]}}</option>
          </select>
        </div>
      </div>
      <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
        <div class="uk-form-controls uk-inline">
          <label class="uk-form-label" for="form-horizontal-text">Ville/Region*</label>

          <select v-model="customerForm.cust_city" class="uk-select uk-input uk-form-width-large uk-border-rounded csa-input">
            <option :value="cust_city" :key="cust_city" v-for="cust_city in region" >{{cust_city}}</option>
          </select>
        </div>
      </div>
      <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
        <div class="uk-inline">
          <label class="uk-form-label" for="form-horizontal-text">Nationalité*</label>
          <select v-model="customerForm.cust_nationality" class="uk-select uk-input uk-form-width-large uk-border-rounded csa-input">
            <option :value="cust_nation" :key="cust_nation" v-for="cust_nation in nationality" >{{cust_nation}}</option>
          </select>
        </div>
      </div>
      <div class="uk-margin-remove-top uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
        <div class="uk-inline">
          <label class="uk-form-label" for="form-horizontal-text">Date d'entrée en cote d'ivoire*</label>
<!--          <span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: user"></span>-->
          <input v-model="customerForm.cust_date_of_entering_ivory_coast" class="uk-input uk-input uk-form-width-large uk-border-rounded csa-input" placeholder="Date d'entrée en cote d'ivoire" type="date" aria-label="Not clickable icon">
        </div>
      </div>
    </form>
    <button class="uk-button uk-button-large csa-btn" @click="saveCustomer()">Valider</button>

  </div>

</template>

<style scoped>

</style>